import { getMappedValueFromI18n } from '../../tppServices/translations/constants';
import { urlGenerator } from './urlGenerators';
import { pathFromSwitcherElement } from './domHelpers';

export const FILTER_NAMES = {
  AVAILABILITY_TYPE: 'availabilityType',
  PAGE: 'page',
};

const updateState = (event, filterName, value, handleDataChange) => {
  event?.preventDefault();
  const path = pathFromSwitcherElement(event?.target);
  handleDataChange(path, filterName, value);
};

export const toAvailabilityType = (value, messages) => {
  const reverseTranslate = getMappedValueFromI18n();
  const availabilities = {
    buy: messages.productSearch.routes.availabilityType.buy,
    rent: messages.productSearch.routes.availabilityType.rent
  };
  const originalFilterKey = reverseTranslate(value, availabilities);
  const originalFilterValue = availabilities[originalFilterKey]?.defaultMessage;
  return {
    filter: 'availabilityType',
    value: originalFilterValue,
    translatedValue: value,
  };
};

//TODO: Missing default selection logic
export const populateBuyRentFilter = (t, messages, handleDataChange, urlState) => {
  const availabilityMsg = messages.productSearch.routes.availabilityType;
  const filterRootName = t(availabilityMsg);

  const buyRentTranslationOpts = [
    t(messages.productSearch.filters.listingTypeFilter.all),
    t(messages.productSearch.filters.listingTypeFilter.buy),
    t(messages.productSearch.filters.listingTypeFilter.rent)
  ];

  const switcherValues = [
    availabilityMsg.buy,
    availabilityMsg.rent
  ].reduce((acc, route) => {
    acc.translationRoutes.push(t(route));
    acc.buyRentOriginalValues.push(route.defaultMessage);
    return acc;
  }, { translationRoutes: [''], buyRentOriginalValues: ['']});

  const generateSwitcherUrl = urlGenerator(urlState, 'availabilityType');
  return populateCollapsibleSwitchFilter(filterRootName, buyRentTranslationOpts, switcherValues, handleDataChange, generateSwitcherUrl);
};

const populateCollapsibleSwitchFilter = (filterName, translationMsgs, switcherValues, handleDataChange, generateSwitcherUrl) => {
  const toolsetRadioItems = [];
  const filterValues = switcherValues.translationRoutes;
  const originalValues = switcherValues.buyRentOriginalValues;
  for (let i = 0; i < translationMsgs.length; i++) {
    let itemsProps = {
      id: `${filterName}-${translationMsgs[i]}`.toLowerCase(),
      name: `${filterName}-${translationMsgs[i]}`.toLowerCase(),
      onClick: (e) => {
        updateState(e, filterName, filterValues[i], handleDataChange);
      },
      value: `${translationMsgs[i]}`,
      url: generateSwitcherUrl(originalValues[i]),
      text: `${translationMsgs[i]}`,
      nofollow: true,
      originalValue: originalValues[i],
    };

    toolsetRadioItems.push(itemsProps);
  }
  return toolsetRadioItems;
};
